import Vue from 'vue'
import Router from 'vue-router'
import Screen from './views/Screen.vue'
import Missing from './views/Missing.vue'
import CustomTable from './views/customTable.vue'
import Admin from './views/Admin.vue'
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/admin/:param1?/:param2?/:param3?',
        name: 'Admin',
        component: Admin,
        beforeEnter(to, from, next) {
            //const socket = io('http://localhost:3000/admin',{
             const socket = io('https://api.screen.itmaster.dk/admin',{
              autoConnect: true,
              query: {
                token: localStorage.token,
              }
            });
            Vue.use(VueSocketIOExt, socket);
            next()
        }
      },
      {
            path: '/:uuid',
            name: 'screen',
            component: Screen,
            beforeEnter(to, from, next) {
              //const socket = io('http://localhost:3000/device',{
              const socket = io('https://api.screen.itmaster.dk/device',{
                  autoConnect: true,
                  query: {
                    uuid: to.params.uuid
                  }
                });
                Vue.use(VueSocketIOExt, socket);
                next()
            }
        },
        {
          path: '/customtable/:id',
          name: 'customtable',
          component: CustomTable,
        },
        {
          path: '/',
          alias: '*',
          name: 'Missing',
          component: Missing,
        }
    ]
})